import QuantificationTable from "./components/QuantificationTable";

export default QuantificationTable